import { router } from 'expo-router';
import { Dimensions, ScrollView, View } from 'react-native';
import {
  createStyleSheet,
  UnistylesRuntime,
  useStyles,
} from 'react-native-unistyles';

import {
  NavigationButton,
  NavigationButtonTypes,
} from '@/components/navigation-button';
import { RentalTerms } from '@/components/rental-terms';
import { Text } from '@/ui';

const PAGE_WIDTH = Dimensions.get('window').width;

export default function RentalTermsScreen() {
  const { styles, theme } = useStyles(stylesheet);

  return (
    <ScrollView
      contentContainerStyle={{
        flexGrow: 1,
        gap: 32,
        alignItems: 'center',
      }}
      style={{
        backgroundColor: theme.colors.background_1,
      }}
      showsVerticalScrollIndicator={false}
    >
      <View style={styles.container}>
        {['md', 'lg'].includes(UnistylesRuntime.breakpoint) ? (
          <View style={{ gap: 16 }}>
            <NavigationButton
              type={NavigationButtonTypes.back_with_text}
              onPress={() => {
                router.back();
              }}
            />
          </View>
        ) : null}

        <ScrollView
          showsVerticalScrollIndicator={false}
          contentContainerStyle={styles.scrollContent}
          style={styles.scrollView}
        >
          <View style={{ flexGrow: 1, gap: 32 }}>
            <View style={{ gap: 16 }}>
              <Text type="largeTitle">Rental Terms</Text>
            </View>

            <RentalTerms />
          </View>
        </ScrollView>
      </View>
    </ScrollView>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flex: 1,
    paddingTop: 24,
    paddingLeft: 16,
    paddingRight: 16,
    gap: 16,
    backgroundColor: theme.colors.background_1,
  },
  scrollView: {
    width: '100%',
    height: '100%',
  },
  scrollContent: {
    width: {
      xs: PAGE_WIDTH - 32,
      md: 1000,
    },
    alignSelf: 'center',
    paddingBottom: 16,
  },
}));
